import React from "react";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import "./styles/Main.css";

export default function Main({ isNight }) {
  return (
    <div className="Main">
      <section className="grid grid-2-columns">
        <div className="border-section-img"></div>
        <div className="border-section">
          <h2>SKILLS</h2>
          <p>
            Under det senaste året har jag lärt mig HTML5, CSS, JS, React.js,
            Astro.js, responsiv webbutveckling, att göra API-calls, Git
            (terminal och GitDesktop), bitbucket, att host:a och integrera
            plug-ins. Jag kan bootstrap men föredrar Tailwindcss. Jag har också
            gjort en minikurs i AI och lärt mig grunderna i Figma. Håller på att
            lära mig allt om CMS (specifikt Sanity och Wordpress).
          </p>
          <div className="icons">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
              <defs>
                <linearGradient
                  id="a"
                  x1="882.997"
                  x2="638.955"
                  y1="27.113"
                  y2="866.902"
                  gradientTransform="scale(.1)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stop-color="#000014" />
                  <stop offset="1" stop-color="#150426" />
                </linearGradient>
                <linearGradient
                  id="b"
                  x1="1001.68"
                  x2="790.326"
                  y1="652.45"
                  y2="1094.91"
                  gradientTransform="scale(.1)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stop-color="#ff1639" />
                  <stop offset="1" stop-color="#ff1639" stop-opacity="0" />
                </linearGradient>
              </defs>
              <path
                fill="url(#a)"
                d="M81.504 9.465c.973 1.207 1.469 2.836 2.457 6.09l21.656 71.136a90.079 90.079 0 0 0-25.89-8.765L65.629 30.28a1.833 1.833 0 0 0-3.52.004L48.18 77.902a90.104 90.104 0 0 0-26.003 8.778l21.758-71.14c.996-3.25 1.492-4.876 2.464-6.083a8.023 8.023 0 0 1 3.243-2.398c1.433-.575 3.136-.575 6.535-.575H71.72c3.402 0 5.105 0 6.543.579a7.988 7.988 0 0 1 3.242 2.402Zm0 0"
              />
              <path
                fill="#ff5d01"
                d="M84.094 90.074c-3.57 3.055-10.696 5.137-18.903 5.137-10.07 0-18.515-3.137-20.754-7.356-.8 2.418-.98 5.184-.98 6.954 0 0-.527 8.675 5.508 14.71a5.671 5.671 0 0 1 5.672-5.671c5.37 0 5.367 4.683 5.363 8.488v.336c0 5.773 3.527 10.719 8.543 12.805a11.62 11.62 0 0 1-1.172-5.098c0-5.508 3.23-7.555 6.988-9.938 2.989-1.894 6.309-4 8.594-8.222a15.513 15.513 0 0 0 1.875-7.41 15.55 15.55 0 0 0-.734-4.735Zm0 0"
              />
              <path
                fill="url(#b)"
                d="M84.094 90.074c-3.57 3.055-10.696 5.137-18.903 5.137-10.07 0-18.515-3.137-20.754-7.356-.8 2.418-.98 5.184-.98 6.954 0 0-.527 8.675 5.508 14.71a5.671 5.671 0 0 1 5.672-5.671c5.37 0 5.367 4.683 5.363 8.488v.336c0 5.773 3.527 10.719 8.543 12.805a11.62 11.62 0 0 1-1.172-5.098c0-5.508 3.23-7.555 6.988-9.938 2.989-1.894 6.309-4 8.594-8.222a15.513 15.513 0 0 0 1.875-7.41 15.55 15.55 0 0 0-.734-4.735Zm0 0"
              />
            </svg>

            <i className="fab fa-html5"></i>
            <i className="fab fa-css3-alt"></i>
            <i className="fab fa-js"></i>
            <i className="fab fa-react"></i>
            <i className="fab fa-bootstrap"></i>
            <i className="fab fa-git-alt"></i>
            <i className="fab fa-figma"></i>
          </div>
        </div>
      </section>
      <Portfolio isNight={isNight} />
      <Contact isNight={isNight} />
    </div>
  );
}
